

import React, { Component } from 'react';
import {

    Button,

} from 'carbon-components-react';


export class InspectionWeekBody extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: this.props.disabled,
            draft: this.props.statusDraft,
            approved: this.props.statusApproved,
            submit: this.props.statusSubmitted,
            planned: this.props.statusPlanned,
        };


    }


    render() {
        ///Cella con lo stato della week
        return (
            <>

                <div className='row-box-info' >
                    <div className='numeric-box-info'>
                        {this.props.draft != 0 ?

                            < div className={this.props.draft != 0 ? (this.props.isDrill ? 'y' :  'g') : ''}  >
                                {this.props.draft != 0 ? this.props.draft : ''}
                            </div>
                            : <div className=''></div>
                        }
                        {this.props.submitted != 0 ?

                            < div className={this.props.submit != 0 ? (this.props.isDrill ? 'o' :  'r') : ''}  >
                                {this.props.submit != 0 ? this.props.submit : ''}
                            </div>
                            : <div></div>
                        }
                        {this.props.approved != 0 ?

                            < div className={this.props.approved != 0 ? 'y' : ''}  >
                                {this.props.approved != 0 ? this.props.approved : ''}
                            </div>
                            : <div></div>
                        }
                        {this.props.planned != 0 ?

                            < div className={this.props.planned != 0 ? (this.props.isDrill ? 'lg' :  'y')  : ''}  >
                                {this.props.planned != 0 ? this.props.planned : ''}
                            </div>
                            : <div></div>
                        }


                    </div>

                </div>
            </>
        );
    }
}

InspectionWeekBody.defaultProps = {
    isDrill: false
  }